// Réduit un contenu de largeur fixe (une fenêtre du dashboard à sa taille
// réelle) à la largeur de son cadre. Renvoie [ref à poser sur le cadre,
// échelle pour `zoom`, recadre]. Sous `minimum`, l'échelle ne baisse plus et
// `recadre` passe à vrai : le côté droit du contenu est coupé.
import { useLayoutEffect, useRef, useState } from "react";

export default function useEchelle(largeur, minimum = 0.5) {
	const ref = useRef(null);
	const [ratio, setRatio] = useState(1);
	useLayoutEffect(() => {
		const element = ref.current;
		if (!element) return undefined;
		const maj = () => setRatio(element.clientWidth / largeur);
		maj();
		if (typeof ResizeObserver === "undefined") return undefined;
		const observateur = new ResizeObserver(maj);
		observateur.observe(element);
		return () => observateur.disconnect();
	}, [largeur]);
	return [ref, Math.min(1, Math.max(minimum, ratio)), ratio < minimum];
}
